export default __webpack_public_path__ + "static/media/le_croise2.d4dcbde7.jpg";